module.exports = __webpack_public_path__ + "img/ysb.2621effb.png";